import { accountConfig } from '@account/configs'
import { Configurable } from '@crystal/config'

import { getMfSiteConfig } from './site-config'

const mfSiteConfig = getMfSiteConfig()

const passwordPolicyRegistration = {
  required: true,
  minLength: 8,
  minNumbers: 1,
  minBigLetters: 1,
  minSpecialCharecters: 1,
  pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[,;:.?!"`'|\\_\-=+/*~#$%&@{([<>\])}])[\S]{8,}$/,
}

const passwordPolicyLogin = {
  required: true,
}

const emailPolicy = {
  required: true,
  pattern: /^([\w+.-]+)@[A-Za-z\d-](?:[A-Za-z\d-.]{0,253})+(?=\.)+(\.([A-Za-z]{2,})+)*$/,
}

const config = {
  emailPolicy,
  passwordPolicyRegistration,
  passwordPolicyLogin,
  legalPolicy: mfSiteConfig.prop('legalPolicy'),
  recaptchaSiteKey: accountConfig.prop('recaptchaSiteKey'),
  socialLoginProviders: mfSiteConfig.prop('socialProviders'),
  suggestSocialLogin: mfSiteConfig.prop('suggestSocialLogin'),
  preSelectedPersistentLogin: mfSiteConfig.prop('preSelectedPersistentLogin'),
  isKmcFlowRequired: mfSiteConfig.prop('isKmcFlowRequired'),
}

export const accountPortalConfig = Configurable.props(config)
export type AccountPortalConfig = ReturnType<typeof accountPortalConfig.evaluateWithContext>
